import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=3876142e&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"
import style0 from "./Register.vue?vue&type=style&index=0&id=3876142e&prod&lang=scss&scoped=true"
import style1 from "./Register.vue?vue&type=style&index=1&id=3876142e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3876142e",
  null
  
)

export default component.exports